export const FF_ICONS_OTHERS = [
  'ff-icon-share',
  'ff-icon-search',
  'ff-icon-x-circle',
  'ff-icon-x',
  'ff-icon-check',
  'ff-icon-mail',
  'ff-icon-arrow-paginate-back',
  'ff-icon-arrow-paginate-next',
  'ff-icon-minus',
  'ff-icon-plus',
  'ff-icon-arrow-dropdown',
  'ff-icon-play-thin',
  'ff-icon-eye-password',
  'ff-icon-goggles',
  'ff-icon-warning-2',
  'ff-icon-warning-1',
  'ff-icon-angle-right',
  'ff-icon-angle-down',
  'ff-icon-check-square',
  'ff-icon-long-arrow-left',
  'ff-icon-long-arrow-right',
  'ff-icon-cube',
  'ff-icon-play-video',
  'ff-icon-share-arrow',
  'ff-icon-play_arrow',
];

export const FF_ICONS_SOCIAL = [
  'ff-icon-logo',
  'ff-icon-social-facebook',
  'ff-icon-social-facebook-f',
  'ff-icon-social-google-plus-new',
  'ff-icon-social-instagram',
  'ff-icon-social-pinterest',
  'ff-icon-social-twitter',
  'ff-icon-social-youtube',
  'ff-icon-social-linkedin',
  'ff-icon-social-wechat',
  'ff-icon-social-weibo',
];

export const FF_ICONS = [
  ...FF_ICONS_OTHERS,
  ...FF_ICONS_SOCIAL
];
